import * as React from 'react';

import Buttons from './Buttons';
import FilterInput from './FilterInput';
import styles from './styles.module.scss';
import type { ButtonData } from '../types';

type Props = {
	hasSearchInput: boolean;
	onFilterTextChange: (filterText: string) => void;
	filterText: string;
	additionalFilter?: () => React.JSX.Element;
	specializedFilters?: () => React.ReactNode;
	buttons: ButtonData[];
	exportAsZip?: boolean;
	filtersClassName?: string;
	openBulkFilter?: () => void;
};

const ActionHeader: React.FC<Props> = (props) => {
	const {
		hasSearchInput,
		onFilterTextChange,
		filterText,
		additionalFilter,
		buttons,
		exportAsZip,
		specializedFilters,
		openBulkFilter,
		filtersClassName,
	} = props;
	const filtersStyle = React.useMemo(() => {

		const appliedStyles = [styles['action-header__filters']];

		if (filtersClassName) {
			appliedStyles.push(filtersClassName);
		}

		return appliedStyles;

	}, [filtersClassName]);

	return (
		<div className={styles['action-header']}>
			<div className={styles.row}>
				<div className={filtersStyle.join(' ')}>
					{hasSearchInput &&
						<FilterInput
							filterText={filterText}
							onFilterTextChange={onFilterTextChange}
							openBulkFilter={openBulkFilter}
						/>
					}
					{additionalFilter?.()}
				</div>
				<Buttons buttons={buttons} exportAsZip={exportAsZip} />
			</div>
			{
				!!specializedFilters
					? <div className={styles.specializedFilters}>{specializedFilters()}</div>
					: <></>
			}
		</div>
	);
};

export default React.memo(ActionHeader);
